<template>
  <div>
    <Navbar activeDirectory="storico" :activePage="activePage"></Navbar>
    <div class="container-fluid py-4">
      <!-- ===== PAGE HEADER ===== -->
      <div class="d-flex align-items-center justify-content-between flex-wrap mb-4" style="gap:12px;">
        <div class="d-flex align-items-center">
          <div class="au-header-icon mr-3">
            <i class="mdi mdi-history"></i>
          </div>
          <div class="text-left">
            <h3 class="mb-0 font-weight-bold text-dark text-uppercase">Storico {{ activePage }}</h3>
            <p class="mb-0 text-muted small">{{ getHistorySubtitle() }}</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="row align-items-end mb-4 au-card p-3 mx-1">
            <div class="col-md-2 mb-3 mb-md-0">
              <label class="font-weight-bold small text-muted text-uppercase mb-2">Stato</label>
              <select class="form-control" style="height: 42px; background: #fff;" v-model="statusFilter">
                <option value="tutti">Tutti</option>
                <option v-if="activePage === 'lavori'" value="in_corso">In corso</option>
                <option v-if="activePage === 'lavori'" value="concluso">Concluso</option>
                <option v-if="activePage === 'segnalazioni'" value="da_gestire">Da gestire</option>
                <option v-if="activePage === 'segnalazioni'" value="in_gestione">In gestione</option>
                <option v-if="activePage === 'richieste'" value="accettata">Presa in carico</option>
                <option v-if="activePage === 'richieste'" value="conclusa_confermata">Conclusa e confermata</option>
                <option v-if="activePage === 'richieste'" value="conclusa_non_confermata">Conclusa e non confermata</option>
              </select>
            </div>
            <div class="col-md-2 mb-3 mb-md-0">
              <label class="font-weight-bold small text-muted text-uppercase mb-2">Interventi</label>
              <div class="dropdown" ref="interventiDropdown">
                <div class="form-control d-flex align-items-center justify-content-between" @click="showInterventi = !showInterventi" style="height: 42px; cursor: pointer; background: #fff;">
                  <span class="text-truncate" style="flex: 1; opacity: 0.8; font-size: 0.9rem;">
                    {{ interventi.length > 0 ? interventi.map(i => i.value).join(', ') : 'Filtra per intervento...' }}
                  </span>
                  <i class="mdi mdi-chevron-down text-muted"></i>
                </div>
                <div class="dropdown-content shadow-lg border-0 w-100 mt-1 rounded" v-show="showInterventi" style="display: block; position: absolute; z-index: 1050; background: white; max-height: 250px; overflow-y: auto;">
                  <div class="dropdown-item py-2" style="cursor: pointer;" v-for="(tag, i) in getExistingTags()" :key="i" @click.stop="toggleIntervento(tag)">
                    <div class="custom-control custom-checkbox d-flex align-items-center" style="pointer-events: none;">
                      <input type="checkbox" class="custom-control-input" :checked="isInterventoSelected(tag)" style="margin-top: 0;">
                      <label class="custom-control-label mb-0" style="margin-left: 8px;">{{ tag.value }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2 mb-3 mb-md-0">
              <label class="font-weight-bold small text-muted text-uppercase mb-2">Squadra</label>
              <div class="dropdown" ref="squadraDropdown">
                <input class="form-control"
                  style="height: 42px;"
                  :name="name"
                  @focus="showOptions()"
                  @keyup="keyMonitor"
                  v-model="squadra"
                  :disabled="disabled"
                  :placeholder="placeholder" />
                <div class="dropdown-content shadow-lg border-0" v-show="optionsShown">
                  <div
                    class="dropdown-item py-2"
                    @mousedown="selectOption(option)"
                    v-for="(option, index) in filteredOptions"
                    :key="index">
                      {{ option.team || option.id || '-' }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2 mb-3 mb-md-0">
              <label class="font-weight-bold small text-muted text-uppercase mb-2">Da</label>
              <input type="date" class="form-control" style="height: 42px;" v-model="dateFrom" />
            </div>
            <div class="col-md-2 mb-3 mb-md-0">
              <label class="font-weight-bold small text-muted text-uppercase mb-2">A</label>
              <input type="date" class="form-control" style="height: 42px;" v-model="dateTo" />
            </div>
            <div class="col-md-2 d-flex mb-3 mb-md-0">
              <button class="btn btn-light font-weight-bold mr-2 flex-grow-1" style="height: 42px;" @click="resetData()">Reset</button>
              <button class="btn btn-primary font-weight-bold flex-grow-1" style="height: 42px;" @click="fetchData()">Mostra</button>
            </div>
          </div>
        </div>
      </div>

      <div class="au-card p-0 overflow-hidden">
        <div class="p-4" v-if="!searching">
          <div class="row px-3" v-if="activePage=='lavori'">
            <div class="table-responsive w-100" v-if="filteredLavoriList.length > 0">
              <table class="au-table">
                <thead>
                  <th>ID</th>
                  <th>Stato</th>
                  <th>Intervento</th>
                  <th>Squadra</th>
                  <th>Presso</th>
                  <th>Avviato</th>
                  <th>Concluso</th>
                  <th>Supporto</th>
                  <th class="text-right">Azioni</th>
                </thead>
                <tbody>
                  <tr v-for="(item, key) in filteredLavoriList" v-bind:key="key" :class="[{'lineThrough' : item.deleted}]">
                    <td class="align-middle font-weight-bold text-muted">#{{ item.id }}</td>
                    <td class="align-middle text-center">
                      <i class="mdi mdi-checkbox-blank-circle h6 mb-0" :class="[{'text-success' : !item.fine.tempo}, {'text-muted': item.fine.tempo}]" v-tooltip="getTooltipOfLavori(item.fine.tempo)"></i>
                    </td>
                    <td class="align-middle">
                      <span class="badge-soft" :class="classeInterventoBadge(item.intervento)">{{ nomeIntervento(item.intervento) }}</span>
                    </td>
                    <td class="align-middle font-weight-semibold">{{ item.team.nome }}</td>
                    <td class="align-middle">{{ item.strada }}</td>
                    <td class="align-middle text-muted small">{{ formatTimestampToLocalDate(item.inizio.tempo) }}</td>
                    <td class="align-middle text-muted small">{{ formatTimestampToLocalDate(item.fine.tempo) }}</td>
                    <td class="align-middle small text-muted"><span v-html="formatSupporto(item.supporto)"></span></td>
                    <td class="align-middle text-right">
                      <button @click="downloadLavoroPDF(item)" class="btn btn-sm btn-outline-danger border-0 mr-1" v-tooltip="{content:'Relazione PDF', placement: 'top'}"><i class="mdi mdi-file-pdf-box h5 mb-0"></i></button>
                      <button @click="mostraDettagliLavoro(item)" class="btn btn-sm btn-outline-primary border-0" v-tooltip="{content:'Dettagli', placement: 'top'}"><i class="mdi mdi-eye-outline h5 mb-0"></i></button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="empty-state" v-else>
              <i class="mdi mdi-history"></i>
              <h5>Nessun lavoro trovato</h5>
              <p>Non sono presenti lavori che corrispondono ai filtri selezionati.</p>
            </div>
          </div>
          <div class="row px-3" v-if="activePage=='segnalazioni'">
            <div class="table-responsive w-100" v-if="filteredSegnalazioniList.length > 0">
              <table class="au-table">
                <thead>
                  <th>ID</th>
                  <th>Intervento</th>
                  <th>Segnalato da</th>
                  <th>Gestito da</th>
                  <th>In data</th>
                  <th>Presso</th>
                  <th class="text-right">Azioni</th>
                </thead>
                <tbody>
                  <tr v-for="(item, key) in filteredSegnalazioniList" v-bind:key="key" :class="[{'lineThrough' : item.deleted}]">
                    <td class="align-middle font-weight-bold text-muted">#{{ item.id }}</td>
                    <td class="align-middle">
                      <span class="badge-soft" :class="classeInterventoBadge(item.intervento)">{{ nomeIntervento(item.intervento) }}</span>
                    </td>
                    <td class="align-middle font-weight-semibold">{{ item.team_segnalatore.nome }}</td>
                    <td class="align-middle text-muted"><span v-if="item.team_operatore">{{ item.team_operatore.nome }}</span><span v-else>-</span></td>                  
                    <td class="align-middle text-muted small">{{ formatTimestampToLocalDate(item.tempo) }}</td>
                    <td class="align-middle">{{ item.strada }}</td>
                    <td class="align-middle text-right">
                      <button @click="mostraDettagliSegnalazione(item)" class="btn btn-sm btn-outline-primary border-0" v-tooltip="{content:'Dettagli', placement: 'top'}"><i class="mdi mdi-eye-outline h5 mb-0"></i></button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="empty-state" v-else>
              <i class="mdi mdi-clipboard-text-clock-outline"></i>
              <h5>Nessuna segnalazione</h5>
              <p>Nessuna segnalazione storica trovata per i criteri indicati.</p>
            </div>
          </div>
          <div class="row px-3" v-if="activePage=='richieste'">
            <div class="table-responsive w-100" v-if="filteredRichiesteList.length > 0">
              <table class="au-table">
                <thead>
                  <th>ID</th>
                  <th>Intervento</th>
                  <th>Richiesto da</th>
                  <th>In data</th>
                  <th>Presso</th>
                  <th>Esito Richiesta</th>
                  <th class="text-right">Azioni</th>
                </thead>
                <tbody>
                  <tr v-for="(item, key) in filteredRichiesteList" v-bind:key="key">
                    <td class="align-middle font-weight-bold text-muted">#{{ item.id }}</td>
                    <td class="align-middle">
                      <span class="badge-soft" :class="classeInterventoBadge(item.intervento)">{{ nomeIntervento(item.intervento) }}</span>
                    </td>
                    <td class="align-middle font-weight-semibold">{{ item.team_richiedente.nome }}</td>
                    <td class="align-middle text-muted small">{{ formatTimestampToLocalDate(item.tempo) }}</td>
                    <td class="align-middle">{{ item.strada }}</td>
                    <td class="align-middle small">{{ formatEsitoRichiesta(item) }}</td>
                    <td class="align-middle text-right">
                      <button @click="mostraDettagliRichiesta(item)" class="btn btn-sm btn-outline-primary border-0" v-tooltip="{content:'Dettagli', placement: 'top'}"><i class="mdi mdi-eye-outline h5 mb-0"></i></button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="empty-state" v-else>
              <i class="mdi mdi-account-question-outline"></i>
              <h5>Nessuna richiesta</h5>
              <p>Non ci sono richieste di supporto nello storico per questo periodo.</p>
            </div>
          </div>
        </div>
        <div class="card-body" v-else>
          <i class="fa fa-spinner fa-spin fa-2x"></i>
        </div>
      </div>
    </div>

    <!-- Modale di una RICHIESTA -->
    <modal name="richiesta" :adaptive="true" :max-width="850" width="90%" height="auto" :scrollable="true">
      <div v-if="forceRefreshRichiesta && Object.entries(richiesta).length > 0">
        <div class="card mb-0 border-0">
          <div class="modal-header-premium d-flex justify-content-between align-items-center">
            <h4 class="mb-0 font-weight-bold text-primary">Dettagli Richiesta</h4>
            <button class="btn btn-light btn-sm rounded-circle" @click="$modal.hide('richiesta')"><i class="mdi mdi-close"></i></button>
          </div>
          <div class="card-body p-4">
            <div class="row">
              <div class="col-md-5">
                <div class="rounded-lg overflow-hidden shadow-sm mb-3">
                  <img :src="richiesta.foto" class="img-fluid w-100" style="object-fit: cover; max-height: 400px; border-radius: 12px;">
                </div>
              </div>
              <div class="col-md-7">
                <div class="modal-section-title"><i class="mdi mdi-information-outline"></i> Informazioni Generali</div>
                <div class="row">
                  <div class="col-6 detail-item">
                    <div class="detail-label">Tipo Intervento</div>
                    <div class="detail-value"><span class="badge-soft" :class="classeInterventoBadge(richiesta.intervento)">{{ nomeIntervento(richiesta.intervento) }}</span></div>
                  </div>
                  <div class="col-6 detail-item">
                    <div class="detail-label">Identificativo</div>
                    <div class="detail-value">#{{ richiesta.id }}</div>
                  </div>
                  <div class="col-6 detail-item">
                    <div class="detail-label">Richiesto da</div>
                    <div class="detail-value font-weight-semibold">{{ richiesta.team_richiedente.nome }}</div>
                  </div>
                  <div class="col-6 detail-item">
                    <div class="detail-label">In data</div>
                    <div class="detail-value">{{ formatTimestampToLocalDate(richiesta.tempo) }}</div>
                  </div>
                  <div class="col-12 detail-item">
                    <div class="detail-label">Esito</div>
                    <div class="detail-value">{{ formatEsitoRichiesta(richiesta) }}</div>
                  </div>
                </div>

                <div class="modal-section-title mt-2"><i class="mdi mdi-map-marker-outline"></i> Posizione</div>
                <div class="detail-item">
                  <div class="detail-label">Indirizzo / Strada</div>
                  <div class="detail-value">{{ richiesta.strada }}</div>
                </div>
                <div class="row">
                  <div class="col-6 detail-item">
                    <div class="detail-label">Latitudine</div>
                    <div class="detail-value font-family-monospace small text-muted">{{ richiesta.latitudine }}</div>
                  </div>
                  <div class="col-6 detail-item">
                    <div class="detail-label">Longitudine</div>
                    <div class="detail-value font-family-monospace small text-muted">{{ richiesta.longitudine }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>      
    </modal>

    <!-- Modale di una SEGNALAZIONE -->
    <modal name="segnalazione" :adaptive="true" :max-width="850" width="90%" height="auto" :scrollable="true">
      <div v-if="forceRefreshSegnalazione && Object.entries(segnalazione).length > 0">
        <div class="card mb-0 border-0">
          <div class="modal-header-premium d-flex justify-content-between align-items-center">
            <h4 class="mb-0 font-weight-bold text-primary">Dettagli Segnalazione</h4>
            <button class="btn btn-light btn-sm rounded-circle" @click="$modal.hide('segnalazione')"><i class="mdi mdi-close"></i></button>
          </div>
          <div class="card-body p-4">
            <div class="row">
              <div class="col-md-5">
                <div class="rounded-lg overflow-hidden shadow-sm mb-3">
                  <img :src="segnalazione.foto" class="img-fluid w-100" style="object-fit: cover; max-height: 400px; border-radius: 12px;">
                </div>
                <div class="text-center" v-if="segnalazione.intervento=='emergenza_carreggiata' || segnalazione.intervento == 'rifiuto' || segnalazione.intervento == 'rifiuto_speciale'">
                  <button class="btn btn-outline-primary btn-block" @click="downloadEmergenza(segnalazione)">
                    <i class="mdi mdi-download mr-1"></i> Scarica Report PDF
                  </button>
                </div>
              </div>
              <div class="col-md-7">
                <div class="modal-section-title"><i class="mdi mdi-information-outline"></i> Informazioni Generali</div>
                <div class="row">
                  <div class="col-6 detail-item">
                    <div class="detail-label">Tipo Intervento</div>
                    <div class="detail-value"><span class="badge-soft" :class="classeInterventoBadge(segnalazione.intervento)">{{ nomeIntervento(segnalazione.intervento) }}</span></div>
                  </div>
                  <div class="col-6 detail-item">
                    <div class="detail-label">Identificativo</div>
                    <div class="detail-value">#{{ segnalazione.id }}</div>
                  </div>
                  <div class="col-6 detail-item">
                    <div class="detail-label">Segnalato da</div>
                    <div class="detail-value font-weight-semibold">{{ segnalazione.team_segnalatore.nome }}</div>
                  </div>
                  <div class="col-6 detail-item">
                    <div class="detail-label">In data</div>
                    <div class="detail-value">{{ formatTimestampToLocalDate(segnalazione.tempo) }}</div>
                  </div>
                  <div class="col-12 detail-item" v-if="segnalazione.team_operatore.id">
                    <div class="detail-label">Gestita da</div>
                    <div class="detail-value font-weight-semibold text-primary"><i class="mdi mdi-account-hard-hat mr-1"></i>{{ segnalazione.team_operatore.nome }}</div>
                  </div>
                </div>

                <div class="modal-section-title mt-2"><i class="mdi mdi-map-marker-outline"></i> Posizione</div>
                <div class="detail-item">
                  <div class="detail-label">Indirizzo / Strada</div>
                  <div class="detail-value">{{ segnalazione.strada }}</div>
                </div>
                <div class="row">
                  <div class="col-6 detail-item">
                    <div class="detail-label">Latitudine</div>
                    <div class="detail-value font-family-monospace small text-muted">{{ segnalazione.latitudine }}</div>
                  </div>
                  <div class="col-6 detail-item">
                    <div class="detail-label">Longitudine</div>
                    <div class="detail-value font-family-monospace small text-muted">{{ segnalazione.longitudine }}</div>
                  </div>
                </div>

                <div class="modal-section-title mt-2"><i class="mdi mdi-note-text-outline"></i> Note</div>
                <div class="detail-item">
                  <p class="text-muted italic small mb-0">{{ segnalazione.note || 'Nessuna nota presente' }}</p>
                </div>
                
                <div class="mt-4 text-center" v-if="tipologia=='B'">
                  <router-link :to="{name: 'modifica-segnalazione', params: {uuid: segnalazione.uuid}}" class="btn btn-primary px-4 shadow-sm">
                    <i class="mdi mdi-pencil-outline mr-1"></i> Modifica
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>      
    </modal>

    <!-- Modale di un lavoro -->
    <modal name="lavoro" :adaptive="true" :max-width="850" width="90%" height="auto" :scrollable="true">
      <div v-if="forceRefreshLavoro && Object.entries(lavoro).length > 0">
        <div class="card mb-0 border-0">
          <div class="modal-header-premium d-flex justify-content-between align-items-center">
            <h4 class="mb-0 font-weight-bold text-primary">Dettagli Intervento Storico</h4>
            <button class="btn btn-light btn-sm rounded-circle" @click="$modal.hide('lavoro')"><i class="mdi mdi-close"></i></button>
          </div>
          <div class="card-body p-4">
            <div class="row">
              <div class="col-md-5">
                <div class="rounded-lg overflow-hidden shadow-sm mb-3">
                  <div v-if="lavoro.fine.tempo" class="position-relative">
                    <div class="lavoro-photo-toggle shadow-sm">
                      <button class="btn btn-sm" :class="mostraFotoLavoro==='inizio' ? 'btn-primary' : 'btn-light'" @click="mostraFotoLavoro='inizio'">Inizio</button>
                      <button class="btn btn-sm" :class="mostraFotoLavoro==='fine' ? 'btn-primary' : 'btn-light'" @click="mostraFotoLavoro='fine'">Fine</button>
                    </div>
                    <img :src="lavoro.inizio.foto" class="img-fluid w-100" style="object-fit: cover; max-height: 400px; border-radius: 12px;" v-if="mostraFotoLavoro==='inizio'">
                    <img :src="lavoro.fine.foto" class="img-fluid w-100" style="object-fit: cover; max-height: 400px; border-radius: 12px;" v-if="mostraFotoLavoro==='fine'">
                  </div>
                  <img :src="lavoro.inizio.foto" class="img-fluid w-100" style="object-fit: cover; max-height: 400px; border-radius: 12px;" v-else>
                </div>
              </div>
              <div class="col-md-7">
                <div class="modal-section-title"><i class="mdi mdi-information-outline"></i> Informazioni Generali</div>
                <div class="row">
                  <div class="col-6 detail-item">
                    <div class="detail-label">Tipo Intervento</div>
                    <div class="detail-value"><span class="badge-soft" :class="classeInterventoBadge(lavoro.intervento)">{{ nomeIntervento(lavoro.intervento) }}</span></div>
                  </div>
                  <div class="col-6 detail-item">
                    <div class="detail-label">Identificativo</div>
                    <div class="detail-value">#{{ lavoro.id }}</div>
                  </div>
                  <div class="col-6 detail-item">
                    <div class="detail-label">Squadra</div>
                    <div class="detail-value font-weight-semibold text-primary"><i class="mdi mdi-account-group mr-1"></i>{{ lavoro.team.nome }}</div>
                  </div>
                  <div class="col-12 detail-item mt-2">
                    <div class="row no-gutters">
                      <div class="col-6 border-right">
                        <div class="detail-label">Avviato</div>
                        <div class="detail-value small">{{ formatTimestampToLocalDate(lavoro.inizio.tempo) }}</div>
                      </div>
                      <div class="col-6 pl-3" v-if="lavoro.fine.tempo">
                        <div class="detail-label">Concluso</div>
                        <div class="detail-value small">{{ formatTimestampToLocalDate(lavoro.fine.tempo) }}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="modal-section-title mt-2"><i class="mdi mdi-map-marker-outline"></i> Posizione & Metriche</div>
                <div class="detail-item">
                  <div class="detail-label">Indirizzo / Strada</div>
                  <div class="detail-value">{{ lavoro.strada }}</div>
                </div>
                <div class="row">
                  <div class="col-6 detail-item" v-if="lavoro.inizio.latitudine">
                    <div class="detail-label">Inizio (Lat, Lon)</div>
                    <div class="detail-value small text-muted font-family-monospace">({{ lavoro.inizio.latitudine }}, {{ lavoro.inizio.longitudine }})</div>
                  </div>
                  <div class="col-6 detail-item" v-if="lavoro.fine.latitudine">
                    <div class="detail-label">Fine (Lat, Lon)</div>
                    <div class="detail-value small text-muted font-family-monospace">({{ lavoro.fine.latitudine }}, {{ lavoro.fine.longitudine }})</div>
                  </div>
                  <div class="col-4 detail-item" v-if="lavoro.distanza">
                    <div class="detail-label">Distanza</div>
                    <div class="detail-value font-weight-bold">{{ lavoro.distanza }} m</div>
                  </div>
                  <div class="col-8 detail-item" v-if="lavoro.distanza">
                    <div class="detail-label">Misura Lineare</div>
                    <div class="detail-value font-weight-secondary">{{ lavoro.distanza_misurata || 0 }} m</div>
                  </div>
                  <div class="col-12 detail-item" v-if="lavoro.numero_buche">
                    <div class="detail-label">Buche riparate</div>
                    <div class="detail-value text-success font-weight-bold h5 mb-0"><i class="mdi mdi-shoveling mr-1"></i>{{ lavoro.numero_buche }}</div>
                  </div>
                </div>

                <div class="mt-4 text-center d-flex align-items-center justify-content-center" style="gap:10px;">
                  <button @click="downloadLavoroPDF(lavoro)" class="btn btn-outline-danger px-4 shadow-sm">
                    <i class="mdi mdi-file-pdf-box mr-1"></i> Relazione PDF
                  </button>
                  <router-link :to="{name: 'modifica-lavoro', params: {uuid: lavoro.uuid}}" class="btn btn-primary px-4 shadow-sm" v-if="tipologia=='B' && lavoro.fine">
                    <i class="mdi mdi-pencil-outline mr-1"></i> Modifica Lavoro
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>      
    </modal>
  </div>
</template>

<script>
import { Navbar } from "@/components";
import { nomeIntervento } from "@/utils/intervento";

export default {
  components: {
    Navbar,
  },
  name: 'Dropdown',
  template: 'Dropdown',
  props: {
    name: {
      type: String,
      required: false,
      default: 'dropdown',
      note: 'Input name'
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Seleziona una squadra',
      note: 'Placeholder of dropdown'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
      note: 'Disable the dropdown'
    },
    maxItem: {
      type: Number,
      required: false,
      default: 30,
      note: 'Max items showing'
    }
  },
  data() {
    return {
     
      tipologia: localStorage.getItem('tipologia'),

      activePage: undefined,
      lotto: 1,
      searching: false,
      team:{},
      teams:[],
      teamTemp:[],
      selected: undefined,
      optionsShown: false,
      squadra: '',
      // Filter
      interventi: [],
      showInterventi: false,
     // squadra:undefined,
      dateFrom: undefined,
      dateTo: null,
      statusFilter: 'tutti',

      // lavori
      lavori: [],
      lavoro: {},
      forceRefreshLavoro: true,
      mostraFotoLavoro: 'inizio',

      // segnalazioni
      segnalazioni: [],
      segnalazione: {},
      forceRefreshSegnalazione: true,

      // richieste
      richieste: [],
      richiesta: {},
      forceRefreshRichiesta: true,
    };
  },

  watch: {
    $route(to, from) {
      if (to.name == "history" && to.path != from.path) {
        this.activePage = this.$route.params.scope;
        this.statusFilter = 'tutti';
        this.fetchData();
      }
    },
    squadra() {
      if (this.filteredOptions.length === 0) {
        this.selected = {};
      } else {
        console.log(this.filteredOptions[0]);
        this.selected = this.filteredOptions[0];
      }
      this.$emit('filter', this.squadra);
    }
  },

  computed: {
    filteredOptions() {
      const filtered = [];
      const regOption = new RegExp(this.squadra, 'ig');
      for (const option of this.teams) {
        if (this.squadra.length < 1 || option.team.match(regOption) ){
          if (filtered.length < this.maxItem) filtered.push(option);

        }
      }
      return filtered;
    },
    filteredLavoriList() {
      if (this.statusFilter === 'tutti') {
        return this.lavori;
      }
      if (this.statusFilter === 'in_corso') {
        return this.lavori.filter(item => !item.fine || !item.fine.tempo);
      }
      if (this.statusFilter === 'concluso') {
        return this.lavori.filter(item => item.fine && item.fine.tempo);
      }
      return this.lavori;
    },
    filteredSegnalazioniList() {
      if (this.statusFilter === 'tutti') {
        return this.segnalazioni;
      }
      if (this.statusFilter === 'da_gestire') {
        return this.segnalazioni.filter(item => !item.team_operatore || !item.team_operatore.id);
      }
      if (this.statusFilter === 'in_gestione') {
        return this.segnalazioni.filter(item => item.team_operatore && item.team_operatore.id);
      }
      return this.segnalazioni;
    },
    filteredRichiesteList() {
      if (this.statusFilter === 'tutti') {
        return this.richieste;
      }
      if (this.statusFilter === 'accettata') {
        return this.richieste.filter(item => item.stato === 'accettata' || item.stato === 'accettato');
      }
      if (this.statusFilter === 'conclusa_confermata') {
        return this.richieste.filter(item => item.stato === 'conclusa e confermata');
      }
      if (this.statusFilter === 'conclusa_non_confermata') {
        return this.richieste.filter(item => item.stato === 'conclusa e non confermata');
      }
      return this.richieste;
    },
  },

  created() {
    // Active page
    this.activePage = this.$route.params.scope;

    // Get lotto
    if (localStorage.getItem("lotto")) {
      this.lotto = localStorage.getItem("lotto");
    }

    // Get dateFrom
    if (localStorage.getItem("dateFrom")) {
      this.dateFrom = localStorage.getItem("dateFrom");
    } 
    // else {
    //   var today = new Date();
    //   var oneDay = 1000 * 60 * 60 * 24;
    //   this.dateFrom = new Date(today - oneDay).toISOString().split("T")[0];
    // }

    // Get dateTo
    if (localStorage.getItem("dateTo")) {
      this.dateTo = localStorage.getItem("dateTo");
    }

    // Get interventi
    if (localStorage.getItem("interventi")) {
      try {
        this.interventi = JSON.parse(localStorage.getItem("interventi"));
      } catch (e) {
        console.error("Error parsing interventi from localStorage", e);
      }
    }

    this.$emit('selected', this.selected);

  },

  mounted() {
    this.fetchData();
    document.addEventListener('click', this.handleOutsideClick);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  },

  methods: {
    nomeIntervento,

    getHistorySubtitle() {
      if (this.activePage === 'lavori') {
        return "Visualizza lo storico degli interventi eseguiti sul territorio";
      }
      if (this.activePage === 'segnalazioni') {
        return "Visualizza lo storico delle segnalazioni inviate dalle squadre";
      }
      if (this.activePage === 'richieste') {
        return "Visualizza lo storico delle richieste di supporto tra le squadre";
      }
      return "Visualizza e consulta l'archivio dei dati storici";
    },
    handleOutsideClick(e) {
      if (this.$refs.interventiDropdown && !this.$refs.interventiDropdown.contains(e.target)) {
        this.showInterventi = false;
      }
      if (this.$refs.squadraDropdown && !this.$refs.squadraDropdown.contains(e.target)) {
        this.optionsShown = false;
      }
    },
    //vue-suggestion 
   selectOption(option) {
      this.selected = option;
      this.optionsShown = false;
      this.squadra = this.selected.team;
      this.$emit('selected', this.selected);
    },
    showOptions(){
      if (!this.disabled) {
        this.squadra = '';
        this.optionsShown = true;
      }
    },
    exit() {
      console.log(this.selected.team);
      this.squadra = this.selected.team;
      
      this.$emit('selected', this.selected);
      this.optionsShown = false;
    },
    // Selecting when pressing Enter
    keyMonitor: function(event) {
      if (event.key === "Enter" && this.filteredOptions[0])
        this.selectOption(this.filteredOptions[0]);
    },
    // Main method
    fetchData() {
      this.searching = true;
      this.fetchTeams();

      // Save local storage
      if (this.dateFrom){
        localStorage.setItem("dateFrom", this.dateFrom);
      }

      if(this.dateTo){
        localStorage.setItem("dateTo", this.dateTo);
      }     

      // Save interventi in local storage
      if (this.interventi) {
        localStorage.setItem("interventi", JSON.stringify(this.interventi));
      }

      var args = []
      

      if ( this.interventi.length > 0 ){
        var interventiArgs = 'interventi='
        for (var i in this.interventi) {
          interventiArgs += `${this.interventi[i].key},`
        }
        interventiArgs = interventiArgs.substring(0, interventiArgs.length - 1);
        args.push(interventiArgs);
      }
      if( this.squadra ) {
        args.push(`squadra=${this.squadra}`)
      }
      
      if( this.dateFrom ) {
        args.push(`date_from=${this.dateFrom}`)
      }

      if( this.dateTo ) {
        args.push(`date_to=${this.dateTo}`)
      }

      args='?'+ args.join('&')

      if (this.activePage == "lavori") {
        this.fetchLavori(args);
      }

      if (this.activePage == "segnalazioni") {
        this.fetchSegnalazioni(args);
      }

      if (this.activePage == "richieste") {
        this.fetchRichieste(args);
      }
    },

    // Reset
    resetData() {
      // Delete dateFrom
      localStorage.removeItem("dateFrom");
      var today = new Date();
      var oneDay = 1000 * 60 * 60 * 24;
      this.dateFrom = new Date(today - oneDay).toISOString().split("T")[0];

      // Delete dateTo
      localStorage.removeItem("dateTo");

      // Delete interventi from localStorage
      localStorage.removeItem("interventi");
      this.interventi = [];

      this.squadra = '';
      this.statusFilter = 'tutti';

      this.fetchData();
    },

    // Fetch "lavori" history
    fetchLavori(args) {
      this.axios.get(`dockyard/${this.lotto}/history` + args).then(response => {
        this.lavori = response.data;
        var self = this;
        setTimeout(function(){
          self.searching = false;
        }, 2000);        
      });
    },

    // Fetch "segnalazioni" history
    fetchSegnalazioni(args) {
      this.axios.get(`notice/${this.lotto}/history` + args).then(response => {
        this.segnalazioni = response.data;
        var self = this;
        setTimeout(function(){
          self.searching = false;
        }, 2000);        
      });
    },

    // Fetch "richieste" history
    fetchRichieste(args) {
      this.axios.get(`support/${this.lotto}/history` + args).then(response => {
        this.richieste = response.data;
        var self = this;
        setTimeout(function(){
          self.searching = false;
        }, 2000);        
      });
    },

    // Custom dropdown methods
    toggleIntervento(tag) {
      const index = this.interventi.findIndex(i => i.key === tag.key);
      if (index > -1) {
        this.interventi.splice(index, 1);
      } else {
        this.interventi.push(tag);
      }
    },
    
    isInterventoSelected(tag) {
      return this.interventi.some(i => i.key === tag.key);
    },
    
    closeInterventi() {
      this.showInterventi = false;
    },

    // Tag in base alla tipologia di intervento
    getExistingTags() {
      var intBase = [
          { key: 'buca', value: 'BUCA' },
          { key: 'sfalcio', value: 'SFALCIO' },
          { key: 'segnaletica', value: 'SEGNALETICA' },
          { key: 'pulizia', value: 'PULIZIA' },
      ]
      var _ext = [
        { key: 'rifiuto', value: 'RIFIUTO' },
        { key: 'rifiuto_speciale', value: 'RIFIUTO SPECIALE' },
        { key: 'emergenza_carreggiata', value: 'EMERGENZA CARREGGIATA' }
      ]
      var intExt = _ext.concat(intBase);

      if (this.activePage == 'segnalazioni') {
        return intExt;
      } else {
        return intBase;
      }
    },

    classeInterventoBadge(intervento) {
      if (!intervento) return 'badge-soft-secondary';
      const lower = typeof intervento === 'string' ? intervento.toLowerCase() : String(intervento).toLowerCase();
      if (lower.includes('buca')) {
        return 'badge-soft-success';
      }
      if (lower.includes('sfalcio')) {
        return 'badge-soft-primary';
      }
      if (lower.includes('segnaletica')) {
        return 'badge-soft-dark';
      }
      if (lower.includes('rifiuto_speciale')) {
        return 'badge-soft-purple';
      }
      if (lower.includes('rifiuto')) {
        return 'badge-soft-warning';
      }
      if (lower.includes('emergenza') || lower.includes('palo')) {
        return 'badge-soft-danger';
      }
      if (lower.includes('pulizia') || lower.includes('cestino')) {
        return 'badge-soft-secondary';
      }
      return 'badge-soft-secondary';
    },

    // Format Timestamp to Local Date
    formatTimestampToLocalDate(ts) {
      if (ts) {
        const today = new Date();
        var tsDate = new Date(ts * 1000);
        if (today.getDate() == tsDate.getDate() && today.getMonth() == tsDate.getMonth() && today.getFullYear() == tsDate.getFullYear()) {
          return `Oggi, ${tsDate.toLocaleTimeString()}`;
        } else {
          return tsDate.toLocaleString();
        }
      } else {
        return "-";
      }
    },

    // Format string for "supporto"
    formatSupporto(sup) {
      if ( sup.tempo && sup.team ) {
        if ( sup.confermato ) {
          return  `Con il supporto di <b>${sup.team}</b>`
        } else {
          if ( sup.accettato ) {
            return  `Supporto accettato da <b>${sup.team}</b>`
          } else {
            return  `Supporto assegnato a <b>${sup.team}</b>`
          } 
        }
      } else {
        if ( sup.tempo ) {
          return `Richiesto il ${this.formatTimestampToLocalDate(sup.tempo)}`
        } else {
          return '-'
        }        
      }
    },

    // Format esito richiesta
    formatEsitoRichiesta(item){
      console.log(item);
      // accettata|conclusa e confermata|conclusa e non confermata
      if ( item.stato === 'accettata' ) {
        return `Presa in carico da ${item.team_supporto.nome}`
      }
      if ( item.stato === 'conclusa e confermata' ) {
        return `Con il supporto di ${item.team_supporto.nome}`
      }
      if ( item.stato === 'conclusa e non confermata' ) {
        return `Conclusa senza il supporto di ${item.team_supporto.nome}`
      }
      return '-'
    },

    // Tootlip dei lavori
    getTooltipOfLavori (tempo) {
      if (!tempo) { return 'Lavoro in corso' }
    },

    // Mostra il modale con i dettagli di un
    // lavoro in corso
    mostraDettagliLavoro(lavoro) {
      this.lavoro = lavoro;
      this.$modal.show('lavoro');
      // turnaround
      this.forceRefreshLavoro = !this.forceRefreshLavoro;
      this.forceRefreshLavoro = !this.forceRefreshLavoro;
      // turnaround end
    },

    // Mostra il modale con i dettagli di una 
    // segnalazione
    mostraDettagliSegnalazione(segnalazione) {
      this.segnalazione = segnalazione;
      this.$modal.show('segnalazione');
      // turnaround
      this.forceRefreshSegnalazione = !this.forceRefreshSegnalazione;
      this.forceRefreshSegnalazione = !this.forceRefreshSegnalazione;
      // turnaround end
    },

     // Mostra il modale con i dettagli di una 
    // richiesta
    mostraDettagliRichiesta(richiesta) {
      this.richiesta = richiesta;
      this.$modal.show('richiesta');
      // turnaround
      this.forceRefreshRichiesta = !this.forceRefreshRichiesta;
      this.forceRefreshRichiesta = !this.forceRefreshRichiesta;
      // turnaround end
    },

    downloadEmergenza(emergenza) {
      var backupEmergenza = JSON.parse(JSON.stringify(emergenza))
      backupEmergenza['data'] = new Date ( backupEmergenza['tempo'] * 1000).toLocaleDateString();
      this.axios.post(`report/emergenza`, backupEmergenza, {responseType: 'blob'}).then(response=>{
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${emergenza.intervento}_${emergenza.strada}_${emergenza.id}.pdf`);
        document.body.appendChild(link);
        link.click();
      })
    },

    downloadLavoroPDF(lavoro) {
      if (!lavoro || !lavoro.uuid) return;
      this.$swal.fire({
        title: "Generazione PDF...",
        text: "Attendere la creazione della relazione.",
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        }
      });

      this.axios({
        url: `dockyard/${lavoro.uuid}/pdf`,
        method: 'GET',
        responseType: 'blob',
      })
      .then((response) => {
        this.$swal.close();
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Relazione_Lavoro_${lavoro.id || lavoro.uuid}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Errore download PDF:", error);
        this.$swal.close();
        this.$swal.fire({
          icon: "error",
          title: "Errore",
          text: "Impossibile generare la relazione in formato PDF.",
        });
      });
    },
    fetchTeams() {
      var params = "";
      this.axios.get(`teams/${this.lotto}${params}`).then(response => {
     
        this.teams = response.data;
        this.teamTemp = this.teams;
      }, error => {
        console.log(error);

        setTimeout(function(){

        },1000); 
      });
    }

  },
};
</script>

<style lang="scss" scoped >
.lineThrough {
  text-decoration: line-through;
    text-decoration-line: line-through;
    text-decoration-style: initial;
    text-decoration-color: initial;
}
 
.dropdown {
    position: relative;
    display: block;
    margin: auto;
    .dropdown-input {
      background: #fff;
      cursor: pointer;
      border: 1px solid #e7ecf5;
      border-radius: 3px;
      color: #333;
      display: block;
      font-size: .8em;
      padding: 6px;
      min-width: 250px;
      max-width: 250px;
      &:hover {
        background: #f8f8fa;
      }
    }
    .dropdown-content {
      position: absolute;
      background-color: #fff;
      width: 100%;
      max-height: 250px;
      border: 0;
      box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
      overflow: auto;
      z-index: 100;
      border-radius: 8px;
      margin-top: 5px;
      
      .dropdown-item {
        color: var(--text-main);
        font-size: 0.9rem;
        padding: 10px 15px;
        text-decoration: none;
        display: block;
        cursor: pointer;
        transition: var(--transition);
        
        &:hover {
          background-color: #FEF1E0;
          color: var(--primary);
        }
      }
    }
}

/* =========================================
   HISTORY — Premium UI (RoadME DS)
   ========================================= */

/* ── Shared tokens from style.md ── */
.cw-section-title {
  font-size: 0.82rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.08em;
  color: #64748b; margin-bottom: 22px;
  display: flex; align-items: center;
}
.cw-step-num {
  width: 22px; height: 22px; border-radius: 50%;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  color: #fff; font-size: 0.7rem; font-weight: 800;
  display: inline-flex; align-items: center; justify-content: center;
  margin-right: 10px; flex-shrink: 0;
}
.cw-label {
  font-size: 0.75rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.07em;
  color: #94a3b8; margin-bottom: 8px; display: block;
}
.cw-input-wrap { position: relative; display: flex; align-items: center; }
.cw-field-icon {
  position: absolute; left: 12px;
  color: #94a3b8; font-size: 1rem; z-index: 2; pointer-events: none;
}
.cw-input {
  width: 100%; height: 46px; padding: 0 14px 0 36px;
  border: 1.5px solid #e2e8f0; border-radius: 10px;
  background: #f8fafc; font-size: 0.92rem; font-weight: 500; color: #1e293b;
  transition: border-color 0.2s, box-shadow 0.2s; outline: none;
}
.cw-input:focus {
  border-color: #F7931E; box-shadow: 0 0 0 3px rgba(247,147,30,0.12); background: #fff;
}
.cw-select-wrap { position: relative; display: flex; align-items: center; }
.cw-select {
  width: 100%; height: 46px; padding: 0 38px 0 36px;
  border: 1.5px solid #e2e8f0; border-radius: 10px;
  background: #f8fafc; appearance: none; -webkit-appearance: none;
  font-size: 0.92rem; font-weight: 500; color: #1e293b;
  cursor: pointer; transition: border-color 0.2s, box-shadow 0.2s; outline: none;
}
.cw-select:focus {
  border-color: #F7931E; box-shadow: 0 0 0 3px rgba(247,147,30,0.12); background: #fff;
}
.cw-select-arrow {
  position: absolute; right: 14px;
  color: #94a3b8; font-size: 1rem; pointer-events: none;
}
.cw-btn-submit {
  display: inline-flex; align-items: center;
  padding: 10px 24px; border: none; border-radius: 30px;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  color: #fff; font-size: 0.88rem; font-weight: 700;
  cursor: pointer; box-shadow: 0 4px 14px rgba(247,147,30,0.35);
  transition: all 0.2s;
}
.cw-btn-submit:hover:not(:disabled) {
  background: linear-gradient(135deg, #E07B00, #C96A00);
  box-shadow: 0 6px 18px rgba(247,147,30,0.45); transform: translateY(-1px);
}
.cw-btn-submit:disabled { opacity: 0.55; cursor: not-allowed; transform: none; }
.cw-footer {
  background: #fff; border-radius: 14px;
  padding: 18px 24px; border: 1px solid rgba(0,0,0,0.05);
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

/* ── Page-specific ── */

/* Header icon */
.au-header-icon {
  width: 48px; height: 48px; border-radius: 14px;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 4px 12px rgba(247,147,30,0.35); flex-shrink: 0;
}
.au-header-icon .mdi { color: #fff; font-size: 1.5rem; }

/* Card */
.au-card {
  background: #fff; border-radius: 16px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.07);
  padding: 28px; border: 1px solid rgba(0,0,0,0.05);
}

/* Table */
.au-table { width: 100%; border-collapse: collapse; }
.au-table thead tr { border-bottom: 2px solid #f1f5f9; }
.au-table thead th {
  padding: 10px 16px; font-size: 0.72rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.07em; color: #94a3b8; background: #f8fafc;
}
.au-table tbody tr { border-bottom: 1px solid #f1f5f9; transition: background 0.15s; }
.au-table tbody tr:hover { background: #f8fafc; }
.au-table td { padding: 14px 16px; vertical-align: middle; }

/* Modal Specifics */
.modal-header-premium {
  padding: 20px 24px;
  background: #fff;
  border-bottom: 1px solid #f1f5f9;
  border-radius: 12px 12px 0 0;
}
.modal-section-title {
  font-size: 0.85rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.08em;
  color: #64748b; margin-bottom: 16px; margin-top: 10px;
  display: flex; align-items: center; border-bottom: 1px solid #f1f5f9; padding-bottom: 8px;
}
.modal-section-title .mdi { margin-right: 6px; font-size: 1.1rem; color: #F7931E; }
.detail-item { margin-bottom: 12px; }
.detail-label { font-size: 0.72rem; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 4px; font-weight: 600; }
.detail-value { font-size: 0.95rem; color: #1e293b; font-weight: 500; }
</style>
